export const environment = {
  production: true,
  noindex: false,
  apiBaseUrl: 'https://core-api.itax.in.th',
  shopBaseUrl: 'https://shop.itax.in.th',
  mainBaseUrl: 'https://www.itax.in.th',
  payrollBaseUrl: 'https://paystation.itax.in.th',
  fbAppID: '370186513140659'
};
